export const organisationQuery = `
  id
  uuid
  name
  subdomain
  pinnedStoryId
  localeId
  chatPromotionEnabled
  restrictDuplicateUrlOfCards
  permissions {
    chatGroupAllowToCreate
    chatP2PAllowToCreate
    organisationInAppMessageAllowToCreate
    organisationPushNotificationAllowToCreate
    organisationTagAllowToManage
  }
  role {
    id
  }
  settings {
    locationPlacesSearchEnabled
  }
  twoFactorForce
  sessionExpirationTime
  sessionExpirationTimeApp
  appLockEnabled
  invitingIntoDefaultChannelsEnabled
  defaultChannelUserRoleId
  appTabsSettings {
    appTabs {
      id
      action {
        type
      }
      defaultIconUrl {
        x1
        x3
      }
      iconUrl {
        x1
        x3
      }
      title {
        language
        localization
      }
    }
    initialAppTabId
  }
`;
